import { VerifierSingleCardTemplate } from "../../../../templates";
import { ChangePersonalDetailsForm, useChangePersonalDetails } from "../../../shared";

const ChangePersonalDetails = (): JSX.Element => {
  const { isLoading, data } = useChangePersonalDetails();

  return (
    <div>
      {!isLoading && (
        <VerifierSingleCardTemplate pageTitle="Change Personal Details">
          {data && <ChangePersonalDetailsForm defaultValues={data} />}
        </VerifierSingleCardTemplate>
      )}
    </div>
  );
};

export default ChangePersonalDetails;
